<template>
  <p class="w-full rounded-md ring-2 ring-blue-700 bg-white px-4 py-2 text-blue-800 text-center">
    <slot />
  </p>
</template>
